import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ArrangementsDisplay, ButtonBar, NoAssetsDisplay, ScreenHeader
} from '../../components';
import { PetArrangementsContext, PetArrangementsProvider } from '../../context';

export function NewWillPetCareScreen() {
  return (
    <PetArrangementsProvider> 
      <NewWillPetCareScreenContents />
    </PetArrangementsProvider>
  );
}

function NewWillPetCareScreenContents() {
  const navigate = useNavigate();
  const { arrangements } = useContext(PetArrangementsContext);
  
  const handleBack = useCallback(() => {
    navigate('../minor-beneficiaries');
  }, [ navigate ]);

  const handleSkip = useCallback(() => {
    navigate('../debt-forgiveness');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../add-pet');
  }, [ navigate ]);

  // TODO: fix arrangements display
  return (
    <div className="new-will-pet-care-screen">
      <ScreenHeader 
        title="Pet Arrangements & Care"
        description="Who will take care of your pets?"
        handleBack={handleBack} 
        steps={6} 
        step={3} 
      />
      
      {
        !arrangements.length ? (
          <div style={{ paddingTop: '64px' }}>
            <NoAssetsDisplay
              icon="pets"
              title="Let's add your pets"
              description="To ensure your pets are cared for, please provide their details and care instructions."
            />
          </div>
        ) : (
          <ArrangementsDisplay pets={arrangements} />
        )
      }

      <ButtonBar
        handleSecondary={handleSkip}
        secondaryText={arrangements.length > 0 ? 'Next' : 'Skip'}
        handlePrimary={handleNext}
        primaryText="Add Pet"
      />
    </div>
  );
}

